import { z } from 'zod/v4';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
import { propertyItemSchema } from './property-shape.js';
const filtersSchema = z.object({});
const facetsSchema = z.object({
    total: z.number().int(),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(propertyItemSchema, facetsSchema);
export const searchPropertiesTool = {
    name: ToolName.SearchProperties,
    category: ToolCategory.CaseInfo,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'List case-level properties — tenant-configured custom fields attached to the case. Useful for tenant-specific context (risk tiers, segment tags, special handling flags). Call with no arguments to see everything. Voucher-, creditor- and customer-level properties are returned inline by get_voucher, get_creditor and get_customer respectively.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-properties.js.map